const styles = theme => ({
  container: {
    display: 'grid',
    gap: '12px',
  },
  title: {
    fontSize: '1.875rem',
    fontWeight: 'bold',
    marginBottom: '1.5rem',
    textAlign: 'center',
    color: '#1f2937',
  },
  label: {
    color: ' var(--mcg-dark, #002E47)',
    fontFamily: 'Inter',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '22px' /* 183.333% */,
  },
  searchInfo: {
    margin: '8px 0',
    padding: '0 8px',
  },
  pagination: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 16,
    gap: 16,
  },
  paginationButton: {
    minWidth: 80,
  },
  select: {
    width: '100%',
    padding: '0.5rem',
    border: '1px solid #d1d5db',
    borderRadius: '0.375rem',
    marginBottom: '1rem',
  },
  input: {
    width: '100%',
    padding: '0.5rem',
    borderRadius: '0.375rem',
    height: '40px',
  },
  slider: {
    width: '100%',
    marginBottom: '1rem',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(5, 1fr)',
    gap: '0.5rem',
    maxHeight: '16rem',
    overflowY: 'auto',
    padding: '8px',
  },
  button: {
    border: '0 !important',
    borderRadius: '8px',
    background: 'var(--Background-Light-Paper, #FFF)',
    display: 'flex',
    width: '32px',
    height: '32px',
    padding: '6px',
    alignItems: 'center',
    margin: 'auto',
  },
  selected: {
    backgroundColor: '#bfdbfe',
  },
  iconPreview: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '1.5rem',
  },
  icon: {
    transition: 'color 0.3s',
    '&:hover': {
      color: '#2563eb',
    },
  },
  loading: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '16rem',
  },
  error: {
    color: '#dc2626',
    textAlign: 'center',
    padding: '1rem',
  },
  searchIcon: {
    color: '#919EAB',
  },
})

export default styles
